import { MandantBereichState } from "@/infrastructure/observables/mandantBereichState";





export class GridExtension {

    public static getFilterValue( state: MandantBereichState) : string {
        if ( state.searchMethod == "Mandant") {
          return GridExtension.mandantFilter(state)
        }
        return GridExtension.bereichsFilter(state)
    }

    private static mandantFilter(value: MandantBereichState) : string {
        let mandanten = ""
        let div = ""
        if ( value.filterItem !== undefined) {
              for(const element of value.filterItem) {
                if ( value.filterItem  &&  element?.mandantId ) {
                  if ( mandanten.indexOf((element.mandantId ?? 0).toString()) < 0) {
                    mandanten = mandanten + div + (element.mandantId ?? 0).toString()
                    div = ","
                  }
                }
              }            
        }
        return mandanten
    }

    private static bereichsFilter(value: MandantBereichState) : string {
      let bereiche = ""
      let div = ""
      if ( value.filterItem !== undefined) {
            for(const element of value.filterItem) {
              if ( value.filterItem  && element?.bereichId ) {
                bereiche = bereiche + div + (element.bereichId ?? 0).toString()
                div = ","
              }
            }            
      }
      return bereiche
    }
}